import DeviceBreakout from "./DeviceBreakout";

export default DeviceBreakout;
